import { useAppStore } from '@/stores/app'

export function useLoading() {
  const appStore = useAppStore()

  function setLoading(status) {
    appStore.setSideEffectLoading(status)
  }

  return { setLoading }
}
